import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Directions = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M17.1863 4.41875C17.5073 3.96934 18.1318 3.86524 18.5812 4.18625L32.5812 14.1862C32.844 14.374 33 14.677 33 15C33 15.3229 32.844 15.626 32.5812 15.8137L18.5812 25.8137C18.1318 26.1347 17.5073 26.0306 17.1863 25.5812C16.8653 25.1318 16.9693 24.5073 17.4188 24.1863L28.8795 16H15C11.6863 16 9 18.6863 9 22V35C9 35.5523 8.55228 36 8 36C7.44772 36 7 35.5523 7 35V22C7 17.5817 10.5817 14 15 14H28.8795L17.4188 5.81372C16.9693 5.49271 16.8653 4.86816 17.1863 4.41875Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Directions;
